<ng-template #addElement let-popover="popover">
  <app-qa-add-question
    [position]="position"
    [hideLabel]="true"
    [question]="question"
    (done)="popover.close()"
  >
  </app-qa-add-question>
</ng-template>

<ng-template #moveToPage let-popover="popover">
  <div class="qa-move-to-page-popover">
    <div class="form-group mb-2">
      <label>{{_(KEYS.EDITOR.TARGET_PAGE)}}</label>
      <app-select2
        [hideButton]="true"
        [hideLabel]="true"
        [options]="movePageSelectOptions"
        [(selected)]="moveTargetPageIndex"
      >
        <option *ngFor="let page of pages; let i = index" [value]="i" [disabled]="i === currentPageIndex">
          {{_(KEYS.EDITOR.PAGE)}} {{i + 1}}{{page.title ? ': ' + page.title : ''}}
        </option>
      </app-select2>
    </div>
    <div class="form-group mb-2">
      <label>{{_(KEYS.EDITOR.INSERT_POSITION)}}</label>
      <div class="form-check">
        <input class="form-check-input" type="radio" name="insertPosition" id="insertStart" value="start" [(ngModel)]="moveInsertPosition">
        <label class="form-check-label" for="insertStart">{{_(KEYS.EDITOR.PAGE_START)}}</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" name="insertPosition" id="insertEnd" value="end" [(ngModel)]="moveInsertPosition">
        <label class="form-check-label" for="insertEnd">{{_(KEYS.EDITOR.PAGE_END)}}</label>
      </div>
    </div>
    <div class="form-group mb-2">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="jumpToPage" [(ngModel)]="moveJumpToPage">
        <label class="form-check-label" for="jumpToPage">{{_(KEYS.EDITOR.JUMP_TO_PAGE)}}</label>
      </div>
    </div>
    <button class="btn btn-success w-100" (click)="executeMoveToPage(popover)">
      <i class="fa fa-share"></i> {{_(KEYS.EDITOR.MOVE_TO_PAGE)}}
    </button>
  </div>
</ng-template>

<div class="qa-question" [class.qa-preview-card]="!classicLayout" [class.qa-classic]="classicLayout" [class.expanded]="classicLayout"
     [class.qa-selected]="selected && !classicLayout" [class.qa-inactive]="!question.options.active"
     id="{{question.id}}" #qaQuestion (click)="classicLayout || selectQuestion()">
  <!-- classic layout: the card of the old editor around the shared property template -->
  <ng-container *ngIf="classicLayout; else modernCard">
    <div class="qa-question-bar">
      <div class="btn-group">
        <button type="button" class="btn qa-position" [ngClass]="question.options.active ? 'btn-success' : 'btn-secondary'">{{position + 1}}</button>
        <button type="button" class="btn btn-primary qa-question-type"><i class="fa" [ngClass]="mapping.icon"></i> {{_(mapping.title)}}</button>
        <button type="button" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.ACTIVE)" [class.qa-btn-active]="question.options.active"
                (click)="question.options.active = !question.options.active"><i class="fa fa-check-circle"></i></button>
        <button type="button" *ngIf="question.format === 'text' || question.format === 'multiValue'" class="btn btn-secondary"
                [ngbTooltip]="_(KEYS.EDITOR.REPEATABLE)" [class.qa-btn-active]="question.options.repeatable"
                (click)="question.options.repeatable = !question.options.repeatable"><i class="fa fa-plus-circle"></i></button>
        <button type="button" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.MARK)" [class.qa-btn-active]="question.options.mark"
                (click)="question.options.mark = !question.options.mark"><i class="fa fa-bookmark"></i></button>
        <button type="button" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.HIDE_IN_PDF)" [class.qa-btn-active]="question.options.hideInPdf"
                (click)="question.options.hideInPdf = !question.options.hideInPdf"><i class="fa fa-file-pdf-o"></i><i class="fa fa-close"></i></button>
        <button type="button" *ngIf="supportsHideInApp" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.HIDE_IN_APP)"
                [class.qa-btn-active]="question.options.hideInApp"
                (click)="question.options.hideInApp = !question.options.hideInApp"><i class="fa fa-mobile"></i><i class="fa fa-close"></i></button>
        <button type="button" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.HIDE_IN_XLS)" [class.qa-btn-active]="question.options.hideInXls"
                (click)="question.options.hideInXls = !question.options.hideInXls"><i class="fa fa-table"></i><i class="fa fa-close"></i></button>
        <button type="button" class="btn btn-secondary qa-mandatory" [ngbTooltip]="_(KEYS.EDITOR.MANDATORY)" [class.qa-btn-active]="question.options.mandatory"
                (click)="question.options.mandatory = !question.options.mandatory"><i class="fa fa-exclamation"></i></button>
        <button type="button" *ngIf="feature.editor.patient.upload" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.UPLOAD)"
                [class.qa-btn-active]="question.options.allowUpload"
                (click)="onAllowUploadChange(!question.options.allowUpload)"><i class="fa fa-upload"></i></button>
        <ng-container *ngIf="hasAssetSupport">
          <button type="button" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.IMAGE)" [class.qa-btn-active]="hasImages()"
                  (click)="openTab(qaQuestion, 'expanded', 'images')"><i class="fa fa-file-image-o"></i></button>
          <button type="button" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.VIDEOS)" [class.qa-btn-active]="hasVideos()"
                  (click)="openTab(qaQuestion, 'expanded', 'videos')"><i class="fa fa-file-video-o"></i></button>
          <button type="button" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.AUDIO)" [class.qa-btn-active]="hasAudio()"
                  (click)="openTab(qaQuestion, 'expanded', 'audio')"><i class="fa fa-file-audio-o"></i></button>
        </ng-container>
        <button type="button" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.DEPENDENCIES)" [class.qa-btn-active]="hasConditions()"
                (click)="openTab(qaQuestion, 'expanded', 'conditions')"><i class="fa fa-code-fork"></i></button>
        <button type="button" *ngIf="hasQuestionnaireVariablesConfig" class="btn btn-secondary" [ngbTooltip]="_(KEYS.EDITOR.VARIABLES)"
                [class.qa-btn-active]="hasVariables()" (click)="openTab(qaQuestion, 'expanded', 'variables')"><i class="fa fa-code"></i></button>
      </div>
    </div>
    <div class="qa-question-buttons">
      <button type="button" class="btn btn-primary" (click)="domHelper.toggleCls(qaQuestion, 'expanded')"><i class="fa fa-toggle-expand"></i></button>
      <button type="button" class="btn btn-danger" (click)="onDelete()"><i class="fa fa-trash"></i></button>
    </div>
    <div class="qa-question-hr"></div>
    <div class="qa-question-handle">
      <div class="btn-group-vertical">
        <button type="button" class="btn btn-primary qa-handle-control"><i class="fa fa-arrows qa-handle-control"></i></button>
        <button type="button" class="btn btn-secondary qa-show-on-expanded" (click)="onPositionChange(position - 1)" [disabled]="isFirstOnPage || position === 0">
          <i class="fa fa-arrow-up"></i>
        </button>
        <span class="btn btn-secondary qa-show-on-expanded qa-position-input">
          <input [value]="position + 1" (change)="onPositionChange(qaClassicPosition.value - 1)" #qaClassicPosition>
        </span>
        <button type="button" class="btn btn-secondary qa-show-on-expanded" (click)="onPositionChange(position + 1)" [disabled]="isLastOnPage">
          <i class="fa fa-arrow-down"></i>
        </button>
        <button type="button" *ngIf="pageViewEnabled && pages.length > 1" class="btn btn-primary qa-show-on-expanded"
                [ngbPopover]="moveToPage" placement="bottom-left" popoverTitle="{{_(KEYS.EDITOR.MOVE_TO_PAGE)}}"
                triggers="manual" container="body" #moveToPagePopover="ngbPopover" (click)="onMoveToPage(moveToPagePopover)">
          <i class="fa fa-share"></i>
        </button>
        <button type="button" class="btn btn-success qa-show-on-expanded" [ngbPopover]="addElement" placement="bottom-left"
                popoverTitle="{{_(KEYS.EDITOR.ADD_ELEMENT)}}" triggers="manual" container="body"
                #addQuestionPopover="ngbPopover" (click)="onAddElement(addQuestionPopover)">
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="qa-classic-body">
      <ng-container *ngIf="classicBodyRendered; else classicBodyPending" [ngTemplateOutlet]="properties"></ng-container>
      <ng-template #classicBodyPending><div class="qa-classic-pending"></div></ng-template>
    </div>
  </ng-container>
  <ng-template #modernCard>
  <div class="qa-preview-topline">
    <span class="qa-preview-number">{{position + 1}}</span>
    <button type="button" class="qa-card-tool qa-handle-control" ngbTooltip="{{_(KEYS.EDITOR.DRAG_ELEMENT)}}"
            [attr.aria-label]="_(KEYS.EDITOR.DRAG_ELEMENT)">
      <i class="fa fa-arrows qa-handle-control" aria-hidden="true"></i>
    </button>
    <span class="qa-preview-type">
      <i class="fa" [ngClass]="mapping.icon" aria-hidden="true"></i> {{_(mapping.title)}}</span>
    <span *ngIf="question.options.mandatory" class="qa-preview-required">{{_(KEYS.EDITOR.MANDATORY)}}</span>
    <button class="qa-card-select" (click)="selectQuestion(); $event.stopPropagation()"
            [attr.aria-pressed]="selected" [attr.aria-label]="_(KEYS.EDITOR.EDIT) + ': ' + (position + 1)">
      <i class="fa fa-sliders" aria-hidden="true"></i> {{_(KEYS.EDITOR.PROPERTIES)}}
    </button>
    <button *ngIf="pageViewEnabled && pages.length > 1" type="button" class="qa-card-tool"
            [ngbPopover]="moveToPage" placement="bottom" container="body" triggers="manual"
            popoverTitle="{{_(KEYS.EDITOR.MOVE_TO_PAGE)}}" #moveToPagePopover="ngbPopover"
            ngbTooltip="{{_(KEYS.EDITOR.MOVE_TO_PAGE)}}" [attr.aria-label]="_(KEYS.EDITOR.MOVE_TO_PAGE)"
            (click)="$event.stopPropagation(); onMoveToPage(moveToPagePopover)">
      <i class="fa fa-share" aria-hidden="true"></i>
    </button>
    <div ngbDropdown container="body" placement="bottom-right" [autoClose]="'outside'" (click)="$event.stopPropagation()">
      <button type="button" class="qa-card-tool qa-card-menu-toggle" ngbDropdownToggle
              ngbTooltip="{{_(KEYS.EDITOR.ELEMENT_ACTIONS)}}" [attr.aria-label]="_(KEYS.EDITOR.ELEMENT_ACTIONS)">
        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
      </button>
      <div ngbDropdownMenu class="qa-card-action-menu">
        <button type="button" ngbDropdownItem (click)="onPositionChange(position - 1)" [disabled]="isFirstOnPage || position === 0">
          <i class="fa fa-arrow-up" aria-hidden="true"></i> {{_(KEYS.EDITOR.MOVE_UP)}}
        </button>
        <button type="button" ngbDropdownItem (click)="onPositionChange(position + 1)" [disabled]="isLastOnPage">
          <i class="fa fa-arrow-down" aria-hidden="true"></i> {{_(KEYS.EDITOR.MOVE_DOWN)}}
        </button>
        <label class="qa-position-control">
          <span>{{_(KEYS.EDITOR.POSITION)}}</span>
          <input type="number" class="form-control" min="1" [value]="position + 1"
                 (change)="onPositionChange(qaPosition.valueAsNumber - 1)" #qaPosition>
        </label>
        <div class="dropdown-divider"></div>
        <button type="button" ngbDropdownItem (click)="onDelete()">
          <i class="fa fa-trash" aria-hidden="true"></i> {{_(KEYS.EDITOR.REMOVE)}}
        </button>
      </div>
    </div>
  </div>
  <div class="qa-preview-clip" [class.qa-preview-clipped]="previewOverflows && !previewExpanded"
       [style.max-height.px]="previewExpanded ? null : previewMaxHeight + previewClipInset" [id]="'qa-preview-' + question.id">
  <div class="qa-preview-content" #previewContent [qaTemplateVariableHighlight]="true"
       [qaTemplateVariablePreview]="true" [qaTemplateVariableLocale]="locale">
    <h3 class="qa-preview-editable qa-template-preview" role="button" tabindex="0" [attr.aria-label]="_(KEYS.EDITOR.EDIT) + ': ' + _(KEYS.EDITOR.TITLE)"
        (click)="focusProperty('title', $event)" (keydown.enter)="focusProperty('title', $event)"
        (keydown.space)="focusProperty('title', $event)" [innerHTML]="previewTitle || _(getTitlePlaceholderKey())"></h3>
    <div class="qa-preview-description qa-preview-editable qa-template-preview" *ngIf="previewDescription"
         role="button" tabindex="0" [attr.aria-label]="_(KEYS.EDITOR.EDIT) + ': ' + _(getDescriptionLabelKey())"
         (click)="focusProperty('description', $event)" (keydown.enter)="focusProperty('description', $event)"
         (keydown.space)="focusProperty('description', $event)" [innerHTML]="previewDescription"></div>
    <div *ngIf="question.format !== 'info'" class="qa-answer-preview qa-preview-options" [ngSwitch]="question.format"
         role="button" tabindex="0" [attr.aria-label]="_(KEYS.EDITOR.EDIT) + ': ' + _(KEYS.EDITOR.OPTIONS)"
         (click)="focusProperty('options', $event)" (keydown.enter)="focusProperty('options', $event)"
         (keydown.space)="focusProperty('options', $event)">
      <div *ngSwitchCase="'text'" class="qa-preview-field" [class.qa-preview-multiline]="question.options.multiline">
        {{question.options.hint?.[locale] || ' '}}
      </div>
      <div *ngSwitchCase="'numeric'" class="qa-preview-field">{{question.options.min ?? '0'}} <span>{{question.options.unit?.[locale]}}</span></div>
      <div *ngSwitchCase="'date'" class="qa-preview-field"><i class="fa fa-calendar-o"></i></div>
      <div *ngSwitchCase="'signature'" class="qa-preview-signature"><i class="fa fa-pencil"></i><div></div></div>
      <app-qa-multi-value-preview *ngSwitchCase="'multiValue'" [question]="question" [locale]="locale"></app-qa-multi-value-preview>
      <div *ngSwitchCase="'matrix'" class="qa-preview-matrix-scroll">
        <table *ngIf="question.elements?.length; else emptyMatrix" class="qa-preview-matrix"
               [style.min-width.px]="140 + (question.elements[0].elements?.length || 0) * 64 + (question.extra === 'scale' ? 120 : 0)">
          <thead>
            <tr>
              <th class="qa-preview-matrix-label"></th>
              <th *ngFor="let column of question.elements[0].elements; let columnIndex = index"
                  [attr.data-qa-option-focus]="'column-' + columnIndex">
                {{(column.title?.[locale] | striptags | htmldecode) || (_(KEYS.EDITOR.COLUMN) + ' ' + (columnIndex + 1))}}
              </th>
              <th *ngIf="question.extra === 'scale'" class="qa-preview-matrix-label"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of question.elements; let rowIndex = index">
              <th scope="row" [attr.data-qa-option-focus]="'row-' + rowIndex">{{(row.title?.[locale] | striptags | htmldecode) || (_(KEYS.EDITOR.ROW) + ' ' + (rowIndex + 1))}}</th>
              <td *ngFor="let column of row.elements; let columnIndex = index"
                  [attr.data-qa-option-focus]="'cell-' + rowIndex + '-' + columnIndex">
                <i class="fa" [ngClass]="question.displayType === 'checkbox' ? 'fa-square-o' : 'fa-circle-o'"></i>
              </td>
              <th *ngIf="question.extra === 'scale'" [attr.data-qa-option-focus]="'appendix-' + rowIndex">{{row.appendix?.[locale] | striptags | htmldecode}}</th>
            </tr>
          </tbody>
        </table>
        <ng-template #emptyMatrix><div class="qa-preview-field"><i class="fa fa-th"></i></div></ng-template>
      </div>
      <ng-container *ngSwitchDefault>
        <div *ngIf="question.elements?.length; else visualPlaceholder" class="qa-preview-answers">
          <div *ngFor="let answer of question.elements; let answerIndex = index"
               [attr.data-qa-option-focus]="'answer-' + answerIndex" [class.qa-preview-field]="answer.displayType === 'text'">
            <i class="fa" [ngClass]="answer.displayType === 'text' ? 'fa-pencil-square-o' :
              (answer.displayType || question.displayType) === 'checkbox' ? 'fa-square-o' :
              (answer.displayType || question.displayType) === 'dropdown' ? 'fa-chevron-circle-down' : 'fa-circle-o'"></i>
            <span [innerHTML]="answer.title?.[locale] || _(KEYS.EDITOR.ENTER_TITLE)"></span>
          </div>
        </div>
        <ng-template #visualPlaceholder><div class="qa-preview-field"><i class="fa" [ngClass]="mapping.icon"></i></div></ng-template>
      </ng-container>
    </div>
  </div>
  </div>
  <button *ngIf="previewOverflows" type="button" class="qa-preview-toggle"
          [attr.aria-expanded]="previewExpanded" [attr.aria-controls]="'qa-preview-' + question.id"
          (click)="togglePreview($event)">
    <span *ngIf="!previewExpanded" class="qa-preview-ellipsis" aria-hidden="true">…</span>
    {{_(previewExpanded ? KEYS.EDITOR.SHOW_LESS : KEYS.EDITOR.SHOW_MORE)}}
    <i class="fa" [ngClass]="previewExpanded ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
  </button>
  </ng-template>
</div>

<div class="qa-insert-between" *ngIf="!classicLayout">
  <button type="button" class="qa-insert-button" [ngbPopover]="addElement" placement="bottom" container="body"
          popoverTitle="{{_(KEYS.EDITOR.ADD_ELEMENT)}}" triggers="manual" #addQuestionPopover="ngbPopover"
          (click)="onAddElement(addQuestionPopover)">
    <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.EDITOR.INSERT_ELEMENT_HERE)}}
  </button>
</div>

<ng-template #properties>
  <div class="qa-properties-content" (input)="markPreviewForCheck()" (change)="markPreviewForCheck()" (click)="markPreviewForCheck()">
    <div class="qa-properties-heading" *ngIf="!classicLayout"><div class="qa-properties-context">
      <span><i class="fa" [ngClass]="mapping.icon"></i> {{position + 1}} · {{_(mapping.title)}}</span>
    </div>
      <button class="btn btn-sm btn-danger" (click)="onDelete()" [attr.aria-label]="_(KEYS.EDITOR.REMOVE)"><i class="fa fa-trash"></i></button>
    </div>
    <label class="qa-property-label" *ngIf="!classicLayout">{{_(KEYS.EDITOR.TITLE)}}</label>
  <div class="qa-question-title" qaFroalaAutoScroll>
    <app-qa-lazy-froala
      [block]="true"
      [options]="titleEditorOptions"
      [allowVariables]="true"
      [variableLocale]="locale"
      [focusRequested]="requestedProperty === 'title'"
      (focusHandled)="requestedProperty = null"
      [model]="question.title[locale]"
      (modelChange)="onPreviewContentChange('title', $event)"
      (blur)="refreshPreview()"
      #titleEditor
    ></app-qa-lazy-froala>
  </div>
    <!-- classic layout: the switches of the card bar replace the checkbox blocks -->
    <div class="qa-property-toggles qa-primary-toggles" *ngIf="!classicLayout">
      <label class="qa-property-toggle">
        <input type="checkbox" [(ngModel)]="question.options.active">
        <span>{{_(KEYS.EDITOR.ACTIVE)}}</span>
      </label>
      <label class="qa-property-toggle">
        <input type="checkbox" [(ngModel)]="question.options.mandatory">
        <span>{{_(KEYS.EDITOR.MANDATORY)}}</span>
      </label>
      <label class="qa-property-toggle" *ngIf="question.format === 'text' || question.format === 'multiValue'">
        <input type="checkbox" [(ngModel)]="question.options.repeatable">
        <span>{{_(KEYS.EDITOR.REPEATABLE)}}</span>
      </label>
    </div>
    <details class="qa-extra-settings" *ngIf="!classicLayout">
      <summary>{{_(KEYS.EDITOR.MORE_SETTINGS)}}
        <span *ngIf="additionalOptionsCount" class="qa-settings-count">{{additionalOptionsCount}} {{_(KEYS.EDITOR.SETTINGS_ACTIVE)}}</span>
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </summary>
      <div class="qa-property-toggles qa-secondary-toggles">
      <label class="qa-property-toggle">
        <input type="checkbox" [(ngModel)]="question.options.mark">
        <span>{{_(KEYS.EDITOR.MARK)}}</span>
      </label>
      <label class="qa-property-toggle">
        <input type="checkbox" [(ngModel)]="question.options.hideInPdf">
        <span>{{_(KEYS.EDITOR.HIDE_IN_PDF)}}</span>
      </label>
      <label class="qa-property-toggle" *ngIf="supportsHideInApp">
        <input type="checkbox" [(ngModel)]="question.options.hideInApp">
        <span>{{_(KEYS.EDITOR.HIDE_IN_APP)}}</span>
      </label>
      <label class="qa-property-toggle">
        <input type="checkbox" [(ngModel)]="question.options.hideInXls">
        <span>{{_(KEYS.EDITOR.HIDE_IN_XLS)}}</span>
      </label>
      <label class="qa-property-toggle" *ngIf="feature.editor.patient.upload">
        <input type="checkbox" [ngModel]="question.options.allowUpload" (ngModelChange)="onAllowUploadChange($event)">
        <span>{{_(KEYS.EDITOR.ALLOW_UPLOAD)}}</span>
      </label>
      </div>
    </details>
  <div class="qa-question-tabs ">
    <label class="qa-property-tab-picker" *ngIf="!classicLayout">
      <span>{{_(KEYS.EDITOR.PROPERTY_SECTION)}}</span>
      <select class="custom-select" [(ngModel)]="activePropertyTab">
        <option *ngIf="mapping.sub" value="contents">{{_(KEYS.EDITOR.OPTIONS)}}</option>
        <option value="descriptions">{{_(getDescriptionLabelKey())}}</option>
        <option *ngIf="hasAssetSupport" value="media">{{_(KEYS.EDITOR.MEDIA)}}</option>
        <option value="conditions">{{_(KEYS.EDITOR.CONDITIONS_TAB)}}</option>
        <option *ngIf="hasQuestionnaireVariablesConfig" value="variables">{{_(KEYS.EDITOR.VARIABLES)}}</option>
      </select>
    </label>
    <ul ngbNav [animation]="false" #qaQuestionTabs="ngbNav" [(activeId)]="activePropertyTab" class="nav-tabs">
      <li [ngbNavItem]="'contents'" *ngIf="mapping.sub">
        <a ngbNavLink draggable="false"><i class="fa fa-level-down"></i> {{_(KEYS.EDITOR.OPTIONS)}}</a>
        <ng-template ngbNavContent>
          <div class="mt-3" [attr.data-qa-options-pane]="question.id">
            <ng-container *ngIf="mapping.sub">
              <ng-container
                *ngComponentOutlet="mapping.sub;
                ndcDynamicInputs: {question: question, mapping: mapping, onFocus: onChildFocus, previewFocusTarget: previewFocusTarget};
                ndcDynamicOutputs: {onParentFocus: onFocusTitle, previewFocusHandled: onPreviewFocusHandled}"
              >
              </ng-container>
            </ng-container>
          </div>
        </ng-template>
      </li>

      <li [ngbNavItem]="'descriptions'">
        <a ngbNavLink draggable="false"><i class="fa fa-font"></i> {{_(getDescriptionLabelKey())}}</a>
        <ng-template ngbNavContent>
          <app-qa-lazy-froala
            class="mt-3"
            [focusRequested]="requestedProperty === 'description'"
            (focusHandled)="requestedProperty = null"
            [options]="descriptionEditorOptions"
            [allowVariables]="true"
            [variableLocale]="locale"
            [block]="true"
            [model]="question.description.text[locale]"
            (modelChange)="onPreviewContentChange('description', $event)"
            (blur)="refreshPreview()"
          ></app-qa-lazy-froala>
        </ng-template>
      </li>

      <li [ngbNavItem]="'media'" *ngIf="hasAssetSupport">
        <a ngbNavLink draggable="false">{{_(KEYS.EDITOR.MEDIA)}}</a>
        <ng-template ngbNavContent>
          <div class="qa-media-navigation" role="group" [attr.aria-label]="_(KEYS.EDITOR.MEDIA)">
            <button *ngFor="let mediaType of mediaTypes" type="button" [class.active]="activeMediaTab === mediaType.id"
                    [attr.aria-pressed]="activeMediaTab === mediaType.id" (click)="activeMediaTab = mediaType.id">
              <i class="fa" [ngClass]="mediaType.icon" aria-hidden="true"></i> {{_(mediaType.label)}}
              <span *ngIf="question.assets?.[mediaType.id]?.length">{{question.assets[mediaType.id].length}}</span>
            </button>
          </div>
          <ng-container *ngFor="let media of [activeMediaTab]">
            <div class="qa-media-grid">
              <ng-container *ngIf="question && question.assets && question.assets[media]">
                <div class="qa-media-tile" *ngFor="let asset of question.assets[media]; let position = index; let last = last">
                  <div class="qa-media-stage" [class.qa-media-stage-audio]="media === 'audio'">
                    <span class="qa-media-position">{{position + 1}}</span>
                    <img *ngIf="media === 'images'"
                         class="qa-question-image"
                         [src]="mediaCenter.getAssetUrl(asset, locale)"
                         (click)="onOpenMediaCenterModal(media, asset)"
                         alt=""
                    />
                    <video *ngIf="media === 'videos'"
                           class="qa-question-video" controls preload="metadata"
                           [attr.poster]="mediaCenter.getPreviewImage(asset, locale)"
                           [src]="mediaCenter.getAssetUrl(asset, locale)"
                    >
                    </video>
                    <ng-container *ngIf="media === 'audio'">
                      <i class="fa fa-music qa-media-audio-icon" aria-hidden="true"></i>
                      <audio controls [src]="mediaCenter.getAssetUrl(asset, locale)"></audio>
                    </ng-container>
                  </div>
                  <input placeholder="{{_(KEYS.EDITOR.DESCRIPTION)}}" class="form-control qa-media-title"
                         [attr.aria-label]="_(KEYS.EDITOR.DESCRIPTION)" [(ngModel)]="asset.title[locale]" />
                  <ng-container *ngIf="media === 'images'">
                    <div class="qa-asset-display-options-title"><i class="fa fa-file-pdf-o mr-1"></i>{{_(KEYS.EDITOR.IMAGE_DISPLAY_OPTIONS)}}</div>
                    <div class="qa-asset-display">
                      <div class="qa-asset-display-options-controls">
                        <div class="d-flex qa-asset-display-options">
                          <input
                            class="form-control qa-asset-width-input mr-2"
                            type="number"
                            min="1" max="100"
                            placeholder="%"
                            ngbTooltip="{{_(KEYS.EDITOR.IMAGE_WIDTH_PERCENT)}}"
                            [disabled]="!!(asset.options && asset.options.fullWidth)"
                            [ngModel]="asset.options && asset.options.widthPercent ? asset.options.widthPercent : null"
                            (ngModelChange)="onAssetWidthPercentChange(asset, $event)"
                          />
                          <select
                            class="form-control"
                            [ngModel]="(asset.options && asset.options.alignment) || 'left'"
                            (ngModelChange)="onAssetAlignmentChange(asset, $event)"
                          >
                            <option
                              *ngFor="let opt of assetAlignmentOptions"
                              [value]="opt.value"
                            >
                              {{_(KEYS.EDITOR[opt.label])}}
                            </option>
                          </select>
                        </div>
                        <label class="mt-1 qa-asset-full-width-label">
                          <input
                            type="checkbox"
                            [ngModel]="!!(asset.options && asset.options.fullWidth)"
                            (ngModelChange)="onAssetFullWidthChange(asset, $event)"
                          />
                          {{_(KEYS.EDITOR.IMAGE_FULL_WIDTH)}}
                        </label>
                      </div>
                      <app-qa-image-display-preview
                        class="qa-asset-display-preview"
                        [imageUrl]="mediaCenter.getAssetUrl(asset, locale)"
                        [widthPercent]="asset.options && asset.options.widthPercent"
                        [alignment]="(asset.options && asset.options.alignment) || 'left'"
                        [fullWidth]="!!(asset.options && asset.options.fullWidth)"
                      ></app-qa-image-display-preview>
                    </div>
                  </ng-container>
                  <div class="qa-media-actions">
                    <button type="button" class="qa-media-btn" [disabled]="position === 0"
                            [attr.title]="_(KEYS.EDITOR.MOVE_LEFT)" [attr.aria-label]="_(KEYS.EDITOR.MOVE_LEFT)"
                            (click)="onMediaPositionChange(position, position - 1, media)">
                      <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="qa-media-btn" [disabled]="last"
                            [attr.title]="_(KEYS.EDITOR.MOVE_RIGHT)" [attr.aria-label]="_(KEYS.EDITOR.MOVE_RIGHT)"
                            (click)="onMediaPositionChange(position, position + 1, media)">
                      <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="qa-media-btn"
                            [attr.title]="_(KEYS.EDITOR.EDIT)" [attr.aria-label]="_(KEYS.EDITOR.EDIT)"
                            (click)="onOpenMediaCenterModal(media, asset)">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="qa-media-btn qa-media-btn-danger"
                            [attr.title]="_(KEYS.EDITOR.REMOVE)" [attr.aria-label]="_(KEYS.EDITOR.REMOVE)"
                            (click)="onDeleteMedia(position, media)">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </ng-container>

              <button type="button" class="qa-media-add" (click)="onOpenMediaCenterModal(media)">
                <i class="fa fa-plus" aria-hidden="true"></i>
                <span *ngIf="media === 'images'">{{_(KEYS.EDITOR.ADD_IMAGES)}}</span>
                <span *ngIf="media === 'videos'">{{_(KEYS.EDITOR.ADD_VIDEOS)}}</span>
                <span *ngIf="media === 'audio'">{{_(KEYS.EDITOR.ADD_AUDIO)}}</span>
              </button>
            </div>
          </ng-container>
        </ng-template>
      </li>

      <li [ngbNavItem]="'conditions'">
        <a ngbNavLink draggable="false"><i class="fa fa-code-fork"></i> {{_(KEYS.EDITOR.CONDITIONS_TAB)}}</a>
        <ng-template ngbNavContent>
          <app-qa-conditions [question]="question" [locale]="locale"></app-qa-conditions>
        </ng-template>
      </li>

      <li [ngbNavItem]="'variables'" *ngIf="hasQuestionnaireVariablesConfig">
        <a ngbNavLink draggable="false"><i class="fa fa-code"></i> {{_(KEYS.EDITOR.VARIABLES)}}</a>
        <ng-template ngbNavContent>
          <ng-container *ngIf="question.format === 'info'; else normal">
            <app-qa-variables [container]="question" [disabledScopes]="{client: true, inline: true, fhir: true, 'pdf-form': true}"
              [focusUpload]="focusUploadVariable" (uploadFocused)="focusUploadVariable = false"></app-qa-variables>
          </ng-container>

          <ng-template #normal>
            <app-qa-variables [container]="question" [disabledScopes]="{inline: disableInlineVarScope, 'pdf-form': disableInlineVarScope}"
              [focusUpload]="focusUploadVariable" (uploadFocused)="focusUploadVariable = false"></app-qa-variables>
          </ng-template>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="qaQuestionTabs"></div>
  </div>  </div>
</ng-template>
